module ProcessEditor {
    "use strict"
    /**
     * Service for fetching and caching the list of variables
     */
    export class PromotedResultVariablesService {
        private variables: string[];
        private savedVariables: ng.IPromise<string[]>;
        private unsavedVariables: IVariablesDictionary = {};
        static $inject = ["$http", "$q", "graphEditDisabled"];
        constructor(private $http: ng.IHttpService, $q: ng.IQService, public graphEditDisabled: boolean) {
            this.savedVariables = graphEditDisabled
                ? $q.resolve([]) // if edit disabled, don't fetch anything
                : this.$http.get("Process/GetPromotedVariables").then(result => {
                    if (result.status === 200) {
                        let data = result.data as Frends.IJsonResponse;
                        return data.data as string[];
                    }
                });

            this.savedVariables.then(data => this.variables = data);
        }

        public setNodePromotedVariable(nodeId: string, newValue: string) {
            this.unsavedVariables[nodeId] = newValue;
            this.savedVariables.then(data => {
                let unsavedVariableNames = _.without(_.values(this.unsavedVariables), undefined);
                this.variables = _.uniq(unsavedVariableNames.concat(data).sort());
            });
        }
    }

    app.service("PromotedResultVariablesService", PromotedResultVariablesService);

    interface IVariablesDictionary {
        [nodeId: string]: string;
    }
}